<style lang="scss" scoped>
.notifications {
	&__fade {
		background-color: rgba(18, 17, 37, 0.78);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 3000;
	}
	&__panel {
		position: fixed;
		left: 0;
		top: 0;
		width: 600px;
		height: 100%;
		background: white;
		z-index: 3001;
		padding: 40px 40px 40px 25px;
	}
	&__header {
		margin-bottom: 30px;
		@include flex-center;
		&__read {
			margin-left: auto;
			padding: 0;
		}
		&__close {
			height: 30px;
		}
		h1 {
			margin: 0;
			margin-left: 20px;
			font-size: 25px;
		}
	}
	&__row {
		@include flex-top;
		margin-bottom: 30px;
		cursor: pointer;
		&.\--read {
			opacity: 0.2;
		}
		&__right {
			margin-left: 20px;
		}
		&__subject {
			font-weight: bold;
			color: $headerColor;
		}
		&__img {
			width: 40px;
			height: 100%;
			vertical-align: middle
		}
	}
	&__body {
		margin-left: 45px;
		overflow: scroll;
		height: 100%;
	}
}
</style>

<template lang="pug">
    .notifications
        transition(name="bounce", enter-active-class="fadeIn", leave-active-class="fadeOut")
            router-link.notifications__fade(v-if="$route.query.notifications", tag="div", :to="{query: { }}")
        transition(name="slideLeft")
            .notifications__panel(v-if="$route.query.notifications")
                .notifications__header
                    img.notifications__close(src="/static/img/icons/arrow-left.svg", @click="close")
                    h1(@click="close") Notifications
                    el-button(type="text", @click="readAllNotifications", v-if="unreadCount").notifications__header__read Mark all as read
                    el-button(type="text", @click="deleteNotifications", v-else-if="count").notifications__header__read Clear all
                .notifications__body
                    empty(:visible="true", :central="true", :compact="true", message="You have no notifications right now", v-if="!count").notifications__empty
                    template(v-else)
                        .notifications__row(v-for="n in Notifications", v-bind:class="{ '--read' : n.read }", v-if="!n.deleted", @click="open(n)")
                            .notifications__row__left
                                img.notifications__row__img(src="/static/img/brand/Wonde-Icon-Colour.svg")
                            .notifications__row__right
                                .notifications__row__subject {{ n.subject }}
                                .notifications__row__message {{ n.message }}
                                .notifications__row__date {{ n.date | time_ago }}
</template>

<script>
import gql from "graphql-tag";
import { map } from "lodash";
require("vue2-animate/dist/vue2-animate.min.css");

export default {
	data() {
		return {
			active: this.$route.query.notifications
		};
	},

	apollo: {
		Notifications: {
			query: gql`
				{
					User {
						id
						Notifications {
							id
							subject
							message
							date
							read
							url
							deleted
						}
					}
				}
			`,
			update: r => r.User.Notifications
		}
	},

	computed: {
		unreadCount() {
			return _.countBy(this.Notifications, row => row.read == false).true;
		},
		count() {
			return _.countBy(this.Notifications, row => row.deleted == false).true;
		}
	},

	methods: {
		async readAllNotifications() {
			await this.readNotifications(map(this.Notifications, "id"));
		},

		async open(notification) {
			window.open(notification.url);
			await this.readNotifications([notification.id]);
		},

		close() {
			this.$router.replace({ query: {} });
		},

		async readNotifications(ids) {
			try {
				const result = await this.$apollo.mutate({
					mutation: gql`
						mutation ChangeNotificationStatus($ids: [String!]!, $action: NotificationChangeAction!) {
							ChangeNotificationStatus(ids: $ids, action: $action) {
								id
								read
								deleted
							}
						}
					`,
					variables: {
						ids,
						action: "read"
					}
				});
			} catch (error) {
				console.error("Error", error);
				this.$message.error("Failed to read notifications");
			}
		},
		async deleteNotifications() {
			try {
				const result = await this.$apollo.mutate({
					mutation: gql`
						mutation ChangeNotificationStatus($ids: [String!]!, $action: NotificationChangeAction!) {
							ChangeNotificationStatus(ids: $ids, action: $action) {
								id
								read
								deleted
							}
						}
					`,
					variables: {
						ids: map(this.Notifications, "id"),
						action: "delete"
					}
				});
			} catch (error) {
				console.error("Error", error);
				this.$message.error("Failed to delete notifications");
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/global/Notifications.vue